<template>
  <div>
    <ul class="card">
      <span class="icon ico-drag"></span>
      <li class="img-item">
        <div class="img-content">
          <img :src="imageUrl" alt="">
        </div>
      </li>
      <li class="title-descr">
        <p class="title">{{title}}</p>
        <p class="description">{{desc}}</p>
      </li>
      <li class="category">
        <span class="img-cat category-1" v-if="cat==1"></span>
        <span class="img-cat category-2" v-if="cat==2"></span>
        <span class="img-cat category-3" v-if="cat==3"></span> 
        <span class="img-cat category-4" v-if="cat==4"></span> 
        <p class="category-name" v-if="cat==1">{{ category_1 }}</p>
        <p class="category-name" v-if="cat==2">{{ category_2 }}</p>
        <p class="category-name" v-if="cat==3">{{ category_3 }}</p>   
        <p class="category-name" v-if="cat==4">{{ category_4 }}</p>   
      </li>
      <li class="interaction" v-if="interaction==1">Enlace</li>
      <li class="interaction" v-if="interaction==2">Mail</li>
      <li class="interaction" v-if="interaction==3">Contacto</li>
      <li class="start-date">{{formatedDate(startdate)}}</li>
      <li class="end-date">{{formatedDate(enddate)}}</li>
      <li class="perfil" v-if="profile_id==1">Clientes</li>
      <li class="perfil" v-if="profile_id==2">No Clientes</li>
      <li class="perfil" v-if="profile_id==3">Todos</li>
      <li class="perfil danger" v-if="profile_id=='x'">Requiere actualziación</li>
      <li class="status">
        <label class="switch">
          <input type="checkbox" v-bind:checked="is_active" @change="handleChange">
          <span class="slider"></span>
        </label>
      </li>
      <li class="actions">
        <button class="icon ico-chart" alt="ver performance" @click="performanceContent"></button>
        <!-- <button class="icon ico-edit" alt="editar"></button> -->
        <router-link class="icon ico-edit" alt="editar" :to="{name:'content_detail',params:{id:offer_id}}">
        </router-link>
        <button class="icon ico-trash" alt="borrar" @click="deleteContent"></button>
      </li>
    </ul>
  </div>
</template>

<script>
import moment from 'moment';

import { mapActions } from 'vuex'

export default {
  name: 'ItemList',
  components: {

  },
  data() { 
    return { 
      category_1: process.env.VUE_APP_CATEGORY_1,
      category_2: process.env.VUE_APP_CATEGORY_2,
      category_3: process.env.VUE_APP_CATEGORY_3,
      category_4: process.env.VUE_APP_CATEGORY_4,
      core_url: process.env.VUE_APP_CORE_HOST 
    }
  },
  props: {
    title: {
      type: String,
      default: "Contenido sin título",
    },
    image: {
      type: String,
      default: "@/assets/no-img.png",
      required: true
    },
    desc: {
      type: String,
      default: "Contenido sin descripción",
    },
    startdate: {
      type: String,
      default: "---",
    },
    enddate: {
      type: String,
      default: "---",
    },
    profile_id: {
      type: String,
      default: "---",
    },
    interaction: {
      type: Number,
      default: 0,
    },
    is_active: {
      type: Boolean,
      default: false,
    },
    cat: {
      type: Number,
      required: true,
      default: 1
    },
    offer_id: {
      type: Number,
      required: true
    }

  },
  methods: {
    handleChange: function(){
      this.is_active = !this.is_active
      this.updateActiveOffer({'offer_id':this.offer_id, 'is_active':this.is_active, 'cat_id': this.cat, 'profile_id':this.profile_id})
        .then(r => {
            if(r==false){
              this.is_active = !this.is_active
              this.$emit('checkContent');
            }
        }, err => {
            console.log("error")
            console.log(err)
        })
    },
    deleteContent: function(){
      this.$emit('deleteContent');
    },
    performanceContent: function(){
      this.$emit('performanceContent');
    },
    formatedDate(_date) {
      if (_date) {
        return moment(_date).format('DD-MM-YYYY')
      }
      return ''
    },
    ...mapActions('offers', [
          'updateActiveOffer'
        ])
  },
  computed: {
      imageUrl: function() {
          return process.env.VUE_APP_CORE_HOST +this.image
      }
  
  }
}
</script>

<style lang="sass">
.itemlist
  width: 100%
  box-sizing: border-box
.danger
  color: red
.card
  box-sizing: border-box
  padding: $xxs
  margin: 4px 8px
  border-radius: 4px
  align-items: center
  display: flex
  flex-direction: row
  justify-content: flex-start
  font-family: $title-font
  font-size: 10px
  border: 1px solid rgba(0,0,0,0)
  &:hover
    border: 1px solid #E5EDF4
    box-sizing: border-box
  li
    list-style-type: none
    text-align: center
    &.img-item
      width:calc(100%/18)
      display: flex
      justify-content: center
      .img-content
        width: 56px
        height: 56px
        background-size: cover
        display: flex
        position: relative
        overflow: hidden
        img 
          width: 100%
          height: auto
          display: flex
          align-self: center
    &.title-descr
      height: 56px
      display: flex
      flex-direction: column
      align-content: flex-start
      padding: 0 $xs
      width: calc(100%/5)
      .title
        font-weight: bold
        text-align: left
      .description
        font-weight: 300
        text-align: left
    &.category
      display: flex
      flex-direction: column
      width: calc(100%/10)
      align-items: center
      .img-cat
        display: block
        width: 32px
        height: 32px
        display: block
        margin-bottom: $xs
      .category-1
        background: url(../assets/icons/categories/cat-01-ac.svg) no-repeat center
      .category-2
        background: url(../assets/icons/categories/cat-02-ac.svg) no-repeat center
      .category-3
        background: url(../assets/icons/categories/cat-03-ac.svg) no-repeat center
      .category-4
        background: url(../assets/icons/categories/cat-04-ac.svg) no-repeat center
    &.interaction
      width: calc(100%/10)
      margin: 0 $xs
    &.perfil
      width: calc(100%/10)
      margin: 0 $xs
    &.start-date
      width: calc(100%/10)
      box-sizing: border-box
      padding: 0 0 0 $sm
    &.end-date
      width: calc(100%/10)
      box-sizing: border-box
      padding: 0 0 0 $sm
    &.status
      width: calc(100%/18)
      display: block
      padding: 0 0 0 $md
    &.actions
      width: calc(100%/5)
      display: flex
      flex-direction: row
      justify-content: center
      box-sizing: border-box
      padding: 0 0 0 $md
      button, a
        border: none
        width: 32px
        height: 32px
        background: none
        display: block
        margin: 0 $sm
      .icon
        font-size: 16px
        color: $dark-grey
        width: auto
        height: auto
        &:hover
          color: $secondary-hover
          cursor: pointer 

.switch
  position: relative
  display: inline-block
  width: 48px
  height: 24px
.switch input
  opacity:  0
  width: 0
  height: 0
.slider
  position: absolute
  cursor: pointer
  top: 0
  left: 0
  right: 0
  bottom: 0
  background-color: #ccc
  transition: 300ms
  border-radius: 34px
.slider:before
  position: absolute
  content: ""
  height: 20px
  width: 20px
  left: 2px
  bottom: 2px
  background: white
  transition: 300ms
  border-radius: 100%
input:checked + .slider
  background: $secondary
input:focus + .slider
  box-shadow: 0 0 1px red
input:checked + .slider:before
  transform: translateX(24px)
.ico-drag
  cursor: move
.ico-drag::before
  content: url('../assets/icons/ico-drag.svg')

</style>